"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnAAnswer = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const styled_1 = require("./styled");
exports.QnAAnswer = react_1.default.memo(({ item }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(styled_1.QnAAnswerStyled, null,
        react_1.default.createElement("div", { className: "question-wrapper", style: { height: '100%' } },
            react_1.default.createElement("div", { className: "field-global-001", style: { height: '100%', alignItems: 'start' } },
                react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.content')),
                react_1.default.createElement("div", { className: "question-content" },
                    react_1.default.createElement("div", null,
                        item ? item[0].content : '',
                        " "),
                    react_1.default.createElement("div", { className: "img_wrap" }, item &&
                        item[0].files.map((file, index) => (react_1.default.createElement("div", { key: index, className: "img" })))))),
            react_1.default.createElement("div", { className: "field-global-001" },
                react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.attachFile')),
                react_1.default.createElement("div", { className: "attach-wrapper" }, item &&
                    item[0].files.map((attach, index) => (react_1.default.createElement("div", { className: "attach-files", key: index },
                        react_1.default.createElement(common_1.Button, { key: index, className: "btn_sliver md_round center body5 cursor attach_item", text: attach, styles: {
                                buttonWrap: {
                                    height: 'fit-content',
                                    maxWidth: isMobile ? 180 : 220,
                                },
                            }, option: {
                                buttonBeforeIcon: {
                                    name: 'file',
                                    color: Colors_1.Colors.dark_tur,
                                    size: 12,
                                    show: true,
                                },
                                buttonAfterIcon: {
                                    name: 'file-down',
                                    color: Colors_1.Colors.accent,
                                    size: 12,
                                    show: true,
                                },
                            } })))))))));
});
